import { FC } from 'react';
import { Flex, Heading } from '@chakra-ui/react';
import { ResReHeader } from '@resolutionlife/ui';
import { DefaultLayout } from '../../layouts/default';

export const FallbackError: FC = () => {
  return (
    <DefaultLayout>
      <ResReHeader />
      <Flex
        data-testid="fallback-error"
        flex="1"
        p="3rem 0"
        direction="column"
        justify="center"
      >
        <Flex p="1rem 2rem" direction="column" align="center">
          <Heading as="h1" mb="6" fontWeight="500">
            An Error Occurred
          </Heading>
          <Heading
            as="h2"
            size="md"
            fontWeight="normal"
            color="gray.600"
            textAlign="center"
          >
            We have logged this error for the technical team to investigate.
          </Heading>
        </Flex>
      </Flex>
    </DefaultLayout>
  );
};
